export default __webpack_public_path__ + "static/media/SenaliLavanyaPeiris.0e8a824f.jpg";